import { useTranslation } from "react-i18next";
import type { YearlyTotal } from "../../lib/dividends-utils";

interface Props {
  data: YearlyTotal;
  active: boolean;
  onClick: () => void;
}

function fmtEur(cents: number): string {
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(cents / 100);
}

export function YearTile({ data, active, onClick }: Props) {
  const { t } = useTranslation();

  const yoyLabel = (() => {
    if (data.yoyPercent === null) return null;
    const pct = (data.yoyPercent * 100).toFixed(1);
    if (data.yoyPercent >= 0) return t("dividends.year.yoyPositive", { percent: pct });
    return t("dividends.year.yoyNegative", { percent: pct });
  })();

  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full text-left rounded-lg p-3 border transition-colors"
      style={{
        borderColor: active ? "var(--accent)" : "var(--border)",
        background: active ? "var(--accent-soft)" : "var(--card)",
        color: active ? "var(--accent)" : "var(--text)",
      }}
      aria-pressed={active}
    >
      <div className="text-xs font-semibold" style={{ color: "var(--muted)" }}>
        {data.year}
      </div>
      <div className="text-lg font-extrabold mt-0.5">{fmtEur(data.totalEur)}</div>
      {yoyLabel && (
        <div
          className="text-[10px] mt-0.5"
          style={{ color: (data.yoyPercent ?? 0) >= 0 ? "var(--pos)" : "var(--neg)" }}
        >
          {yoyLabel}
        </div>
      )}
    </button>
  );
}
